import Botox from "..";

const routes = [
    { name: "DermaVisitaList", path: "/paziente/botox/visita", component: Botox.VisitaBotox.VisitaBotoxList, meta: { title: "Visita Botox" } },
    { name: "VisitaBotoxEdit", path: "/paziente/botox/visita/edit/:id", component: Botox.VisitaBotox.VisitaBotoxEdit, meta: { title: "Visita Botox" } },
    { name: "VisitaBotoxView", path: "/paziente/botox/visita/view/:id", component: Botox.VisitaBotox.VisitaBotoxView, meta: { title: "Visita Botox" } },
    { name: "AnamnesiBotoxList", path: "/paziente/botox/anamnesi", component: Botox.AnamnesiBotox.AnamnesiBotoxList, meta: { title: "Anamnesi Botox" } },
    { name: "VisitaBotoxEdit", path: "/paziente/botox/anamnesi/edit/:id", component: Botox.AnamnesiBotox.AnamnesiBotoxEdit, meta: { title: "Anamnesi Botox" } },
    { name: "VisitaBotoxView", path: "/paziente/botox/anamnesi/view/:id", component: Botox.AnamnesiBotox.AnamnesiBotoxView, meta: { title: "Anamnesi Botox" } },
];

export default routes;